import { FormattedMessage } from 'react-intl';

import { GetCardControlsResponse } from '@clients/domains/flexControls/flexControlAccountClient';
import LimitBar from '@components/limitBar/LimitBar';
import FlexControlType from '@enums/flexControls/type';

const FlexControlLimitBar = ({
    flexControl,
}: {
    flexControl: GetCardControlsResponse;
}) => {
    const title =
        flexControl?.type === FlexControlType.SPENDING ? (
            <FormattedMessage
                id="FlexControlLimitBar.spendingLimit"
                defaultMessage="Spending limit"
            />
        ) : (
            <FormattedMessage
                id="FlexControlLimitBar.usageLimit"
                defaultMessage="Usage limit"
            />
        );
    return (
        <LimitBar
            primaryStackValue={
                flexControl?.max_limit - flexControl?.available_limit
            }
            denominatorValue={flexControl?.max_limit}
            remainingValue={flexControl?.available_limit}
            primaryStackIsError={flexControl?.available_limit < 0}
            title={title}
            valuesAsCurrency={flexControl?.type === FlexControlType.SPENDING}
            alert={
                flexControl?.available_limit < 0 && (
                    <FormattedMessage
                        id="LimitBar.overTheLimit"
                        defaultMessage="Limit reached"
                    />
                )
            }
        />
    );
};

export default FlexControlLimitBar;
